<template>
    <b-row class="mb-2">
        <b-col class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start align-items-center">
            <span class="rows_per_page">Rows per page</span>
            <b-form-select
                size="sm"
                :options="perPageOptions"
                v-model="rowsPerPage"
                @change="onPerPageChange"
                class="per_page_select"
            />

            <span class="entry_info">Showing {{fromItemIndex}} to {{toItemIndex}} of {{totalRows}} entries</span>
        </b-col>

        <b-col class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end mt-2 mt-md-0">
            <b-pagination
                size="sm"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="rowsPerPage"
                @change="onPageChange"
                :limit="pagingLimit"
            ></b-pagination>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        totalRows: Number,
        currentPage: Number,
        perPage: Number,
        pagingLimit: Number,
        onPageChange: Function,
        onPerPageChange: Function
    },
    data() {
        return {
            perPageOptions: [
                {
                    text: 50,
                    value: 50
                },
                {
                    text: 100,
                    value: 100
                },
                {
                    text: 200,
                    value: 200
                }
            ],
            rowsPerPage: this.perPage
        };
    },
    watch: {
        perPage: function(newVal, oldVal) {
            this.rowsPerPage = newVal;
        }
    },
    computed: {
        fromItemIndex: function() {
            let fromIndex = (this.currentPage - 1) * this.rowsPerPage + 1;

            return fromIndex;
        },
        toItemIndex: function() {
            let toIndex = (this.currentPage) * this.rowsPerPage;

            if (toIndex > this.totalRows)
                return this.totalRows;

            return toIndex;
        }
    }
};
</script>

<style scoped>
    .per_page_select {
        max-width: 5rem;
    }
    .rows_per_page {
        margin-right: 1rem;
    }
    .entry_info {
        margin-left: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination.vue